import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Card } from 'react-bootstrap'
import Swal from 'sweetalert2'
import ReactPaginate from 'react-paginate'
import { Link } from 'react-router-dom'
// import admindata from '../../components/admindata'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { apiRequest } from '../../store/allApi'
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
const $ = require('jquery')
$.Datatable = require('datatables.net')

const PineLabDesposit = () => {
  const history = useHistory()
  const [user, setUser] = useState()
  const [allDeposite, SetallDeposite] = useState()
  const [amount, setAmount] = useState(0)
  const [searchList1, setSearchList1] = useState(0)
  const [reason, setReason] = useState(0)
  const [utr, setUtr] = useState(0)
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  

  const beckendLocalApiUrl = process.env.REACT_APP_API_BASE_URL
  const beckendLiveApiUrl = process.env.REACT_APP_API_BASE_URL
  const nodeMode = process.env.NODE_ENV
  if (nodeMode === 'development') {
    var baseUrl = beckendLocalApiUrl
  } else {
    baseUrl = beckendLiveApiUrl
  }

  const userData = localStorage.getItem("userData");
  const Number = localStorage.getItem("Number");

  //use for pagination..
  let [limit, setLimit] = useState(10)

  const setpageLimit = event => {
    let key = event.target.value
    setLimit(key)
  }
  const [pageNumber, setPageNumber] = useState(0)
  const [numberOfPages, setNumberOfPages] = useState(0)

  //user for searching..
  const [searchList, setSearchList] = useState(0)
  const [searchType, setSearchType] = useState(0)
  const [findByStatus, setFindByStatus] = useState(0)

  //   searching handler
  const searchHandler = event => {
    let key = event.target.value

    setSearchList(key)
  }
  //   search by status handler
  const searchByStatus = event => {
    let key = event.target.value
    setFindByStatus(key)
  }
  const searchHandler1 = event => {
    let key = event.target.value
    setSearchList1(key)
  }
  const amountAdd = event => {
    let key = event.target.value
    setAmount(key)
  }
  const reasonToAdd = event => {
    let key = event.target.value
    setReason(key)
  }
  const utrToAdd = event => {
    let key = event.target.value
    setUtr(key)
  }

 
  //react paginate..
  const handlePageClick = async data => {
    let currentPage = data.selected + 1
    setPageNumber(currentPage)
    // scroll to the top
    //window.scrollTo(0, 0)
  }

  const profle =async () => {
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    
    try {
      const res = await apiRequest(`txn/deposit/allmanual?page=${pageNumber}&_limit=${limit}&_q=${searchList}&_stype=${searchType}&_status=Pending`, "GET", null, headers)
      if (res.data) {
        setUser(res?.data?.admin)
        setNumberOfPages(res.data.totalPages)
      }
  } catch (e) {
      // setLoading(false)

  }
  finally {
  }
  }

   // edit payment

   const EditPayment = (amount, txnId) =>{
    Swal.fire({
      title: 'Submit your Payment details',
      input: 'number',
      inputValue: amount,
      inputAttributes: {
        autocapitalize: 'on'
      },
      showCancelButton: true,
      confirmButtonText: 'Submit',
      showLoaderOnConfirm: true,
      preConfirm: (login) => {
        const requestData = {
          amount: login,
          txnId: txnId
        };
      
        const access_token = localStorage.getItem('token')
        return  fetch(baseUrl + '/transaction_edit_users', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${access_token}` // Set the appropriate content type
          },
          body: JSON.stringify(requestData), // Convert the login data to JSON
        })
          .then(response => {
            profle()
            if (!response.ok) {
              throw new Error(response.statusText)
            }
            return response.json()
          })
          .catch(error => {
            Swal.showValidationMessage(
              `Request failed: ${error}`
            )
          })
      },
      allowOutsideClick: () => !Swal.isLoading()
    })
    // .then((result) => {
    //   if (result.isConfirmed) {
    //     Swal.fire({
    //       title: `${result.value.login}'s avatar`,
    //       imageUrl: result.value.avatar_url
    //     })
    // }
    // })
  }


  const depositAdd =async () => {
    handleClose()
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }

    try {
      const res = await apiRequest(`depositupdate/whatsapp`, "POST", {
                "Phone": searchList1,
          "amount": amount,
          "reason": reason,
          "UTR": utr,
      }, headers)
      if (res) {
            if (res.data.status == false) {
          Swal.fire({
            title: "Oops...",
            text: res.data.message,
            icon: "error",
          });
          // window.location.reload()
        }
        else {
          Swal.fire({
            title: "deposit success",
            text: res.data.message,
            icon: "success",
          });
          window.location.reload()
        }
      }
  } catch (e) {
           Swal.fire({
          title: "Oops...",
          text: e.message,
          icon: "error",
        });
        if (e.data.status == 401) {
          localStorage.removeItem('token');
          localStorage.removeItem('uData');
          localStorage.removeItem('PData');

          localStorage.removeItem('token');
          localStorage.removeItem('uData');
          localStorage.removeItem('PData');

          window.location.reload()
        }

  }
  finally {
  }
  }
 




  const universalCheckDeposit = (payment_gatway, order_id, order_token, pay_date, ) => {
    //alert(payment_gatway);
    if (window.confirm("Are you sure you want to proceed with this payment?")) {
 if(payment_gatway == 'upigateway'){
      checkupigatewaypay(order_id, order_token, pay_date)
    }
    else if(payment_gatway == 'paymanual'){
      checkupigatewaypaymanual(order_id, order_token, pay_date, 'SUCCESS')
    }
    else if(!payment_gatway){
      withdrowFail(order_id)
    }else{
      alert('Nothing found');
    }
  }}



  const checkupigatewaypay =async (order_id, order_token, pay_date) => {

    const access_token = localStorage.getItem("token")
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
  
    try {
      const res = await apiRequest(`depositupipay/response`, "POST", { order_id, order_token }, headers)
      if (res.data) {
     const icon = res.data.status == "PAID" ? "success" : "danger";
        const title = res.data.status == "PAID" ? "Deposit submited successfully" : "Transaction Failed";
        profle();
      }
  } catch (e) {
         if (e.response.status == 401) {
          localStorage.removeItem('token');
          localStorage.removeItem('token');
          window.location.reload()
        }

  }
  finally {
  }
  }

  const checkupigatewaypaymanual =async (order_id, order_token, pay_date,status) => {

    
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
   
    try {
      const res = await apiRequest(`userdipositupdate/${order_id}`, "POST", { status, status }, headers)
      if (res.data) {
     const icon = res.data.status == "PAID" ? "success" : "danger";
        const title = res.data.status == "PAID" ? "Deposit submited successfully" : "Transaction Failed";
        profle();
      }
  } catch (e) {
         if (e.response.status == 401) {
          localStorage.removeItem('token');
          localStorage.removeItem('token');
          window.location.reload()
        }

  }
  finally {
  }
  }
  const PaymanualReject = async (order_id) => {

    const { value: manualPaymentInput } = await Swal.fire({
      title: 'Enter Reject Payment Details',
      input: 'text',
      inputPlaceholder: 'Enter Reject Msg here',
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return 'Payment details cannot be empty!';
        }
      },
    });

    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
      
     
      try {
        const res = await apiRequest(`userdipositupdate/${order_id}`, "POST", { status: "FAILED",msg: manualPaymentInput  }, headers)
        if (res.data) {
       const icon = res.data.status == "PAID" ? "success" : "danger";
          const title = res.data.status == "PAID" ? "Deposit submited successfully" : "Transaction Failed";
          profle();
        }
    } catch (e) {
         
    }
    finally {
    }
    
  }


  const withdrowFail =async (id) => {
    const confirm = window.confirm(
      'Are you sure, you want to update to failed this deposit?'
    )
    if (confirm) {
      const access_token = localStorage.getItem('token')
      const headers = {
        Authorization: `Bearer ${access_token}`
      }

    
      try {
        const res = await apiRequest(`userdipositupdate/${id}`, "POST", { status: 'FAILED'}, headers)
        if (res) {
          profle()
          alert('deposit successfully reject')
        }
    } catch (e) {
        // setLoading(false)

    }
    finally {
    }
    }
  }

  // check in

  const dateFormat = e => {
    const date = new Date(e)
    const newDate = date.toLocaleString('default', {
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      hour12: true,
      minute: 'numeric'
    })
    return newDate
  }

  const newdateFormat = e => {
    let today = new Date(e)
    let dd = String(today.getDate()).padStart(2, '0')
    let mm = String(today.getMonth() + 1).padStart(2, '0') //January is 0!
    let yyyy = today.getFullYear()
    today = dd + '-' + mm + '-' + yyyy
    return today
  }

  useEffect(() => {
    profle()
  }, [pageNumber, limit, searchList, searchType, findByStatus])

  if (user == undefined) {
    return null
  }

  const Invoice = (data) => {
    const userData = { data }
    setUser(userData);
    console.log(userData)
    history.push('/Reports/deposit_manual', { userData })
  }


  return (
    <>
      {/* <h4 className='font-weight-bold my-3'>ALL CHALLANGES</h4> */}
      <div className='row mt-5'>
        <div className='col-12 grid-margin'>
          <div className='card '>
            <div className='card-body text-light table_bg'>
              <h4 className='dashboard_heading'>Deposit Manual</h4>
                 {/* {admindata?.user?.usertype == 'Admin'? ( */}
                <div className='row'>
                  <input
                    type='number'
                    placeholder='Phone...'
                    className='form-control col-sm-3 m-2'
                    onChange={searchHandler1}
                    required
                  />
                  <input
                    type='number'
                    placeholder='Amount...'
                    className='form-control col-sm-3 m-2'
                    onChange={amountAdd}
                    required
                  />
                  <input
                    type='text'
                    placeholder='Reason...'
                    className='form-control col-sm-2 m-2'
                    onChange={reasonToAdd}
                    required
                  />
                  <input
                    type='number'
                    placeholder='Utr...'
                    className='form-control col-sm-2 m-2'
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value.length >= 6) {
                        utrToAdd(e);
                      }
                    }}
                    required
                  />
                  <button className='btn btn-primary' style={{margin:"auto",display:"block"}} onClick={depositAdd}> Add payment </button>
                </div>
              {/* ) : (
                ""
              )} */}
              {/* searching */}
              <div className='row'>
                <select
                  className='form-control col-sm-3 m-2'
                  id='searchType'
                  name='searchtype'
                  onChange={e => setSearchType(e.target.value)}
                >
                  <option value='0'>Select Search by</option>
                  {/* <option value='Name'>Name</option> */}
                  <option value='Phone'>Phone</option>
                  <option value='_id'>TxnId</option>
                  <option value='order_token'>UTR</option>
                </select>
                <input
                  type='text'
                  placeholder='Search...'
                  className='form-control col-sm-4 m-2'
                  onChange={searchHandler}
                />
                <h5>Or</h5>
              
                <select
                  className='form-control col-sm-1 m-1 text-light'
                  id='pagelimit'
                  name='pagelimit'
                  onChange={setpageLimit}
                >
                  <option value='10'>Set limit</option>
                  <option value='20'>20</option>
                  <option value='50'>50</option>
                  <option value='100'>100</option>
                  <option value='500'>500</option>
                </select>
              </div>

              <div className='table-responsive'>
                <table className='table text-light'>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>ORDER ID</th>
                      <th> Phone</th>
                      <th> User</th>
                      <th> UTR</th>
                      <th> ScreenShot</th>
                      <th> Amount </th>
                      <th> Status </th>
                      <th> Date </th>
                      <th> ----- </th>
                      <th> Action </th>
                    </tr>
                  </thead>

                  <tbody>
                    {user &&
                      user.map((data, key) => {
                        return (
                          <tr>
                            <td>{key + 1}</td>

                            <td
                              style={{
                                color:
                                  data.payment_gatway === 'phonepe'
                                    ? 'red'
                                    : 'black'
                              }}
                            >
                              {data.payment_gatway === 'phonepe' ? (
                                <span>
                                  {data.payment_gatway}-{data._id}
                                  <br />
                                  Order ID: {data?.order_id}
                                </span>
                              ) : (
                                data._id
                              )}
                            </td>

                            <td>
                                <span className='pl-2'>
                                {userData == 'Admin' || 
                          Number === "true" ? (
                            <> 
                           {data.User_id?.Phone}
                            </>
                          ) : (
                            <>
                            {`${
                               '********' + data.User_id?.Phone.toString().slice(-2)
                             }`}
                            </>
                          )}
                                </span>
                            </td>
                            <td>
                              {data.User_id && (
                                <Link
                                  className='btn btn-sm btn-outline-info'
                                  to={`/user/view_user/${data.User_id._id}`}
                                >
                                  {data.User_id.Name}
                                </Link>
                              )}
                            </td>

                            <td>
                             <span style={{color:"blue"}}>{data.order_token}</span> 
                           
                            </td>
                            <td>
                              <a  href={`${baseUrl}/${data?.paymentImage}`} target="_blank">
                            <img
                              alt=''
                              src={baseUrl + `/${data?.paymentImage}`}
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = 'https://t4.ftcdn.net/jpg/04/73/25/49/360_F_473254957_bxG9yf4ly7OBO5I0O5KABlN930GwaMQz.jpg';
                              }}
                              className=''
                              height={600}
                            />
                              </a>
                           
                            </td>
                            <td>{data.amount}</td>
                            <td className='font-weight-bold text-success'>
                              {data.status}
                            </td>
                            


                            <td>{dateFormat(data.createdAt).split(',')[0]} </td>
                            <td>
                            {
                            //&& (parseInt(gameCreatedAt) + 7200000) < currentTime
                              (data.status != 'PAID' && data.status != 'FAILED' ) ? <button className="btn btn-danger" onClick={() => universalCheckDeposit(data.payment_gatway, data.order_id,data._id, data.order_token, newdateFormat(data.createdAt))} >Approve</button> : 'Checked All'
                            }


                            {
                              //   <button className="ml-1 btn btn-sm btn-warning" onClick={() => withdrowPass(data._id)}>Success</button>
                            }
                          </td>
                            <td>
                              {/* <button
                                className='btn btn-primary mr-2'
                                onClick={() => Invoice(data)}
                              >
                                View
                              </button> */}
                              {data.status != "FAILED" && data.status != "PAID" &&
                              <>
                               <button
                                className='btn btn-danger mr-2'
                                onClick={() => PaymanualReject(data.order_id)}
                              >
                                reject
                              </button>
                              <button
                                className='btn btn-danger mr-2'
                                onClick={() => EditPayment(data.amount, data._id)}
                              >
                                Edit
                              </button>
                              </>
                              }
                             
                            </td>
                          </tr>
                        )
                      })}
                  </tbody>
                </table>
              </div>

              <div className='mt-4'>
                <ReactPaginate
                  previousLabel={'Previous'}
                  nextLabel={'Next'}
                  breakLabel={'...'}
                  pageCount={numberOfPages}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={'pagination justify-content-center'}
                  pageClassName={'page-item'}
                  pageLinkClassName={'page-link'}
                  previousClassName={'page-item'}
                  previousLinkClassName={'page-link'}
                  nextClassName={'page-item'}
                  nextLinkClassName={'page-link'}
                  breakClassName={'page-item'}
                  breakLinkClassName={'page-link'}
                  activeClassName={'active'}
                />
              </div>


            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default PineLabDesposit
